var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":_vm.__('Status recusado', 'settings'),"description":_vm.__(
      'Status que permitem finalizar a lead sem orçamento, eles precisam estar na lista de concluídos',
      'settings'
    ),"param-id":"lead_completed_without_value_statuses"}})
}
var staticRenderFns = []

export { render, staticRenderFns }